const colorAlertMap = {
  error: "alert",
  warning: "warning"
};
export default statusColorMap => ({
  methods: {
    getStatusColor(status) {
      return statusColorMap[status] || "info";
    },
    getAlertClass(status) {
      return colorAlertMap[this.getStatusColor(status)];
    }
  }
});
